import authService from "../../services/authService";
import http from "../../services/httpService";

// const apiEndpoint = "/hedge-brown-server/api/dept-or-prgms";
const apiEndpoint = "/api/committees";


function create(data) {
   return http.post(apiEndpoint, data);
}

function update(data) {
  
  return http.put(apiEndpoint, data);
}

function get(id) {
  return http.get(`${apiEndpoint}/${id}`);
}

function getByName(name) {
  return http.get(`${apiEndpoint}/name/${name}`);
}

function getAll() {
  return http.get(apiEndpoint);
}

function getAllByInstitute(instituteId) {
  return http.get(`${apiEndpoint}/list/${instituteId}`);
}


function deleteById(id) {
  return http.delete(`${apiEndpoint}/${id}`);
}

export default {
  create,
  update,
  get,
  getByName,
  getAll,
  getAllByInstitute,
  deleteById
};
